document.addEventListener("DOMContentLoaded", () => {

  const popup = document.getElementById("workshop-popup-overlay");
  const checkbox = document.getElementById("workshop-popup-confirm");
  const continueButton = document.getElementById("workshop-popup-checkout");

  if (!popup || !checkbox || !continueButton) return;

  continueButton.disabled = true;

  checkbox.addEventListener("change", () => {
    continueButton.disabled = !checkbox.checked;
  });

  document.addEventListener("click", async (event) => {

    const checkoutButton = event.target.closest("#CartDrawer-Checkout");

    if (!checkoutButton) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const cart = await fetch("/cart.js").then(r => r.json());

    let madeToOrderCount = 0;

    cart.items.forEach(item => {
      if (item.properties && item.properties._made_to_order === "true") {
        madeToOrderCount += item.quantity;
      }
    });

    if (madeToOrderCount < 3) {
      window.location.href = "/checkout";
      return;
    }

    popup.hidden = false;

  }, true);

  continueButton.addEventListener("click", () => {
    if (!checkbox.checked) return;
    window.location.href = "/checkout";
  });

});